import * as go from 'gojs';

import { ProjectResourceType } from 'src/constants/project';
import { Diagram } from 'src/containers/ProjectDiagram/types/diagram';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { isResource } from 'src/containers/ProjectDiagram/utils/data';
import { createResource } from 'src/containers/ProjectDiagram/utils/resource/createResource';
import {
  ProjectFileUpload,
  ProjectVirtualGraph,
} from 'src/store/state/projects';

export const addProjectResourceToDiagramModel =
  (
    projectResource: ProjectFileUpload | ProjectVirtualGraph,
    type: ProjectResourceType
  ) =>
  (model: Model, diagram: Diagram) => {
    const resourceProps = {
      fields: projectResource.fields,
      value: projectResource.id,
      text: projectResource.name,
    };
    const node =
      type === ProjectResourceType.VIRTUAL_GRAPH
        ? createResource({
            ...resourceProps,
            dataSourceType: (projectResource as ProjectVirtualGraph)
              .dataSourceType,
            type,
          })
        : createResource({
            ...resourceProps,
            type,
          });

    const safePosition =
      diagram.viewportBounds?.center?.isReal() &&
      !go.Point.stringify(diagram.viewportBounds.center).includes('NaN')
        ? go.Point.stringify(diagram.viewportBounds.center)
        : '0 0';

    const hasNodeAtOrigin = model.nodeDataArray.some(
      (nodeData) => 'pos' in nodeData && nodeData.pos === safePosition
    );

    if (!hasNodeAtOrigin) {
      node.pos = safePosition;
    }

    const resource = model.nodeDataArray.find(
      (nodeData) => isResource(nodeData) && nodeData.key === node.key
    );
    if (resource) {
      console.warn(
        'Resource already exists in addProjectResourceToDiagramModel, refusing to add duplicate',
        { key: node.key }
      );
    } else {
      model.addNodeData(node);
    }
  };
